/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react'
import { TypesAuth, TypesUser, useAuth, useUser } from '../../Store'
import {cleanDocument, cleanNumber, validateDocument} from '../../Utils'
import LoginPage from './Components/Login'
import { useHistory } from "react-router-dom";
import {ScreensEnum} from "../Feedback/Feedback.controller";
import Header from "./Components/Header";
import {useSignInAuth} from "../Login/services/login.actions";

export const LoginController: React.FC = () => {
  const [localState, setLocalState] = useState({
    loading: false,
    enable: false,
    error: false,
    errorMessage: '',
    openModal: false,
    documentVerified: false,
    hasManyUsers: false,
    store: '',
    password: '',
    user: '',
    securityText: true,
    buttonEnabled: false,
    toggle: false,
    toggleEye: false
  })

  const { verifyCellcardDocument, signIn } = useSignInAuth()
  const [authState, authDispatch] = useAuth()
  const history = useHistory();

  const [document, setDocument] = useState('')
  const [user, setUser] = useState('')
  const [, userDispath] = useUser()
  const [password, setPassword] = useState('')

  const handleOnChange = (e: any) => {
    setDocument(e)
  }

  const handleOnChangeUser = (e: any) => {
    setUser(e)
  }

  const handleOnChangePassword = (e: any) => {
    setPassword(e)
  }

  async function onVerifyDocument(): Promise<void> {
    if (validateDocument(document)) {
      console.log(document, 'DOCUMENT')
      setLocalState({
        ...localState,
        error: false,
        errorMessage: '',
        loading: true
      })

      try {
        const response = await verifyCellcardDocument({
          variables: { document: cleanNumber(document) }
        })

        setLocalState({
          ...localState,
          loading: false,
          documentVerified: true,
          hasManyUsers:
            response?.data?.CellcardVerifyDocument?.many_users_found || false
        })
        userDispath({
          type: TypesUser.SetLogin,
          payload: {
            document,
            username: user,
          }
        })
      } catch (error) {
        //@ts-ignore
        const responseError = error?.graphQLErrors?.[0]?.extensions?.response
        const code = responseError?.body?.code
        const status = responseError?.status

        console.error(responseError)
        console.error(code)
        console.error(status)

        if (code === 'duplicate_store_error') {
          setLocalState({ ...localState, loading: false })
          userDispath({
            type: TypesUser.SetLogin,
            payload: {
              document,
              username: user,
              hasStore: true
            }
          })
          // _next('password')
          return
        }

        if (status === 404) {
          setLocalState({
            ...localState,
            error: true,
            errorMessage: 'CPF inválido ou não cadastrado',
            loading: false
          })
        }
      }
    } else {
      setLocalState({
        ...localState,
        error: true,
        errorMessage: 'Documento inválido'
      })
    }
  }

  const onSubmitSignIn = async (): Promise<void> => {
    setLocalState({
      ...localState,
      error: false,
      errorMessage: '',
      loading: true
    })

    try {


      console.log(localState, 'localState')
      const variables = {
        variables: {
          document: cleanDocument(document),
          login: user?.trim(),
          store: localState?.store?.trim(),
          password: password,
        },
      };

      // const variables = await buildSignInOauthPayload()
      const response = await signIn(
        variables
      )

      const data = response?.data?.SignIn
      const accessToken = data?.access_token
      const idToken = data?.id_token
      const refreshToken = data?.refresh_token
      const expiresIn = data?.expires_in

      console.log(response, 'response')

      const tokens = {
        hubJWT: { accessToken, expiresIn: 300 },
        userJWT: { accessToken, expiresIn, refreshToken, idToken },
        legalPersonJWT: {
          accessToken: '',
          expiresIn: '',
          username: '',
          document: ''
        },
        accountType: 'naturalPerson'
      }

      // Salvando os tokens no localStorage
      localStorage.setItem('authTokens', JSON.stringify(tokens))

      authDispatch({
        type: TypesAuth.setUserTokens,
        payload: {
          accessToken,
          expiresIn,
          idToken,
          refreshToken
        }
      })

      history.replace({
        pathname: "/feedback",
        state: { type: ScreensEnum.OPERATION_PERFORMED_SUCCESSFULLY },
      });
    } catch (error: any) {
      const responseError = error?.graphQLErrors?.[0]?.extensions?.response
      const status = responseError?.status
      console.error(responseError)

      setLocalState({
        ...localState,
        error: true,
        errorMessage:
          status === 404
            ? 'CPF inválido ou não cadastrado'
            : 'Erro ao efetuar o login',
        loading: false
      })
    } finally {
      setPassword('')
      setLocalState((prevState) => ({
        ...prevState,
        loading: false
      }))
    }

    async function buildSignInPayload() {
      return {
        input: {
          document: cleanNumber(document),
          login: localState?.user?.trim(),
          store: localState?.store?.trim(),
          password: password
        }
      }
    }

    async function buildSignInOauthPayload() {
      return {
        document: cleanNumber(document),
        login: localState?.user?.trim(),
        store: localState?.store?.trim(),
        password: password
      }
    }
  }

  const handle = {
    actions: {
      onChangeDocument: handleOnChange,
      onChangeUser: handleOnChangeUser,
      onChangePassword: handleOnChangePassword,
      onVerifyDocument,
      onSubmitSignIn,
      closeModal: () => {
        setLocalState({ ...localState, openModal: false })
      },
      openModal: () => {
        setLocalState({ ...localState, openModal: true })
      }
    },
    variables: {
      document,
      password,
      modalOpen: localState.openModal,
      user,
      error: localState.error,
      errorMessage: localState.errorMessage,
      enable: localState.enable,
      loading: localState.loading,
      hasManyUsers: localState.hasManyUsers,
      documentVerified: localState.documentVerified
    }
  }

  return (
    <>
      <Header />
      {/* @ts-ignore */}
      <LoginPage {...handle} />
    </>
  )
}
